import { autoinject, BindingEngine, customElement, computedFrom } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { watch } from 'aurelia-watch-decorator';
import { UsersLocationsQueryFilter } from 'model/users-locations';
import { EnumsService } from 'services/enums-service';
import { KeywordsService } from 'services/keywords-service';
import { LookupsService } from 'services/lookups-service';
import { ModelBase } from 'support/base_classes/model-base';
import { LISTS_DEBOUNCE } from 'support/settings';
import { AutocompleteOptions } from '../../framework/html_behaviors/af-autocomplete';

@autoinject
@customElement('users-locations-list-filter')
export class UsersLocationsListFilterCustomElement extends ModelBase<UsersLocationsQueryFilter> {
  debounceMs = LISTS_DEBOUNCE;
  @bindable locationSelectingClicked: () => unknown = null;
  @bindable isLocationSelecting: boolean = false;

  constructor(private lookups: LookupsService, private keywords: KeywordsService, public enums: EnumsService, bindingEngine: BindingEngine) {
    super(bindingEngine);
  }

  locationSelectingIconClicked() {
    if(!this.isLocationSelecting)
      this.locationSelectingClicked();
  }

  @watch((x: UsersLocationsListFilterCustomElement) => x.model.text)
  textChanged() {
    if (this.model.text != null && this.model.text.length > 0 && this.model.user?.name != this.model.text)
      this.model.user = null;
  }

  @watch((x: UsersLocationsListFilterCustomElement) => x.model.site)
  siteChanged() {
    if(this.model.site) {
      this.model.selectedLocation = null;
    }
  }

  usersLookupOptions = this.lookups.getUsersLookupOptions();

  @computedFrom('model.country')
  get sitesLookupOptions(): AutocompleteOptions {
    return this.lookups.getSitesLookupOptions(this.model.country);
  }
}
